import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface ComboFieldProps {
  id: string;
  value: string | null;
  label: string;
  name: string;
  options?: string[];
  readonly?: boolean;
  onChange: (field: string, value: string) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  FormHelperTextProps?: any; // Agrega esta línea para permitir la prop
}

const ComboField: React.FC<ComboFieldProps> = ({
  id,
  value,
  name,
  label,
  options,
  readonly,
  onChange,
  onBlur,
  error,
  helperText,
  FormHelperTextProps,
}) => {
  return (
    <div>
      <Autocomplete
        disablePortal
        id={'ac_' + id}
        options={options || []}
        value={value || null}
        onChange={(_, value) => onChange(name, value ?? '')}
        isOptionEqualToValue={(option, value) =>
          option === value || (option === '' && value === null)
        }
        onBlur={onBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            name={name}
            id={id}
            disabled={readonly}
            error={error}
            helperText={helperText}
            FormHelperTextProps={FormHelperTextProps} // Pasar la prop al TextField
          />
        )}
        disabled={readonly}
      />
    </div>
  );
};

export default ComboField;
